import APP from 'src/main.js'
import Event from './Event.js'

class FeeCancel extends Event {
  get fee_expected(){
    let value = (this.constructor.employeeStore.event_relations.find(rel => (rel.child_id===this.id)&&(rel.parent_type==='FeeExpected'))||{}).parent_id
    if(value){
      return this.constructor.employeeStore.events.find(ev => (ev.id===value)&&ev.id)
    } else {
      return null
    }
  }
  get fee_payment(){
    let value = (this.constructor.employeeStore.event_relations.find(rel => (rel.child_id=== this.id)&&(rel.parent_type==='FeePayment'))||{}).parent_id
    if(value){
      return this.constructor.employeeStore.events.find(ev => (ev.id===value)&&ev.id)
    } else {
      return null
    }
  }
}
export default FeeCancel
